import { Address } from '@/actions/dtos/location';

export const formatAddress = (address?: Address): string | null => {
  if (!address) {
    return null;
  }

  const { addressLineOne, addressLineTwo, postalCode, city, country, region } = address;

  const parts: (string | undefined)[] = [];

  if (addressLineOne) parts.push(addressLineOne);
  if (addressLineTwo) parts.push(addressLineTwo);
  if (postalCode && city) {
    parts.push(`${postalCode} ${city}`);
  } else {
    if (postalCode) parts.push(postalCode);
    if (city) parts.push(city);
  }
  if (region) parts.push(region);
  if (country) parts.push(country);

  return parts.length > 0 ? parts.join(', ') : '-';
};
